import { Button, Flex, Image } from "@chakra-ui/react";
import SideBarMenuBuilder from "./components/sideBarMenuBuilder";
// import SideBarChatCard from "./components/sideBarChatCard";
import { FaBars, FaHamburger, FaXing } from "react-icons/fa";
import { useSetRecoilState, useRecoilState } from "recoil";
import { customColors } from "../../atoms/customColors";
import { useCookies } from "react-cookie";
import { useEffect } from "react";
import { refreshGlobal } from "../../atoms/refreshGlobal";

function SideBar({ setOpen }: any) {
  const colors = useRecoilState(customColors)[0];
  const [cookies, setCookie, removeCookie] = useCookies(['color', 'logo']);
  const refresh = useRecoilState(refreshGlobal)[0];

  const setColors = useSetRecoilState(customColors);

  useEffect(() => {
    if (cookies.color) {
      setColors({
        ...colors,
        BLUEMONEDDBUTTONS: cookies.color.BLUEMONEDDBUTTONS ? cookies.color.BLUEMONEDDBUTTONS : colors.BLUEMONEDDBUTTONS,
        VARIANT: cookies.color.VARIANT ? cookies.color.VARIANT : colors.VARIANT,
      })
    }
  }, [cookies.color, refresh])

  return (
    <Flex
      w="100%"
      h="100vh"
      // bgColor={cookies.color.VARIANT ? cookies.color.VARIANT : "#0078d4"}
      style={{
        background: `linear-gradient(to Bottom,   ${cookies.color ?
          cookies.color.VARIANT ?
            cookies.color.VARIANT : colors.BLUEMONEDDRGB
          :
          colors.BLUEMONEDDRGB
          }, ${cookies.color ?
            cookies.color.BLUEMONEDDBUTTONS ? cookies.color.BLUEMONEDDBUTTONS : colors.BLUEMONEDDRGB2
            :
            colors.BLUEMONEDDRGB2
          } , ${cookies.color ?
            cookies.color.BLUEMONEDDBUTTONS ? cookies.color.BLUEMONEDDBUTTONS : colors.BLUEMONEDDRGB2
            :
            colors.BLUEMONEDDRGB2
          })`,
      }}
      flexDirection="column"
      margin={"auto"}
      justifyContent={"space-between"}
    >
      <Flex
        borderBottom={"1px solid #FFFFFF"}
        justifyContent={"space-between"}
        alignItems="center"
        w={"100%"}
        maxH={"8%"}
      >
        <Button
          bg={"none"}
          onClick={() => setOpen(false)}
        >
          <FaBars color={"white"} width={"50px"} />
        </Button>
        <Image
          w={
            cookies.logo ?
              "25%"
              :
              "80%"}
          mr={cookies.logo ? "35%" : "0"}
          src={
            cookies.logo && cookies.logo !== null ?
              cookies.logo
              :
              '/images/logoBranca.png'
          }
        />
      </Flex>
      <Flex direction="column">
        <SideBarMenuBuilder />
      </Flex>
      <Flex h={"30%"} w={"fit-content"} justifyContent="center">
        {/* <SideBarChatCard /> */}
      </Flex>
    </Flex>
  );
}
export default SideBar;
